import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const footerLinks = {
    categories: categories.slice(0, 6),
    guides: [
      { name: 'Buying Guide', url: 'https://kaspreadsheet.com/', external: true },
      { name: 'Best Finds 2026', url: '/best-kakobuy-spreadsheet-2026-updated-weekly', external: false },
      { name: 'How to Use', url: 'https://kaspreadsheet.com/', external: true },
      { name: 'Safety Review', url: 'https://kaspreadsheet.com/', external: true },
    ],
    safety: [
      { name: 'QC Inspection Tips', url: 'https://kaspreadsheet.com/', external: true },
      { name: 'Shipping Advice', url: 'https://kaspreadsheet.com/', external: true },
      { name: 'Trusted Sellers', url: 'https://kaspreadsheet.com/', external: true },
      { name: 'Secure Payment', url: 'https://kaspreadsheet.com/', external: true },
    ],
    resources: [
      { name: 'About Kakobuy', url: 'https://kaspreadsheet.com/', external: true },
      { name: 'Blog', url: '/best-kakobuy-spreadsheet-2026-updated-weekly', external: false },
      { name: 'FAQ', url: '#faq', external: false },
      { name: 'Contact', url: 'https://kaspreadsheet.com/', external: true },
    ],
  };

  return (
    <footer className="bg-background-50 pt-20 pb-10 px-6 md:px-12 lg:px-20">
      <div className="max-w-[1400px] mx-auto">
        {/* Top Links */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-16">
          {Object.entries(footerLinks).map(([key, links]) => (
            <div key={key}>
              <h4 className="text-foreground-950 font-bold text-sm uppercase tracking-wide mb-5 pb-3 border-b border-foreground-200">
                {key}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    {link.external ? (
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-foreground-500 text-sm hover:text-foreground-950 transition-colors duration-150"
                      >
                        {link.name}
                      </a>
                    ) : (
                      <Link
                        to={link.url}
                        className="text-foreground-500 text-sm hover:text-foreground-950 transition-colors duration-150"
                      >
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pt-10 border-t border-foreground-200">
          <div>
            <span className="text-foreground-950 text-2xl md:text-3xl font-black font-heading block">Kakobuy Spreadsheet</span>
            <span className="text-foreground-500 text-sm">Resource Hub</span>
            <div className="w-10 h-0.5 bg-foreground-800 mt-2"></div>
            <p className="text-foreground-400 text-xs mt-3 max-w-[300px]">
              The largest Kakobuy Spreadsheet resource hub. Helping shoppers find the best products since 2026.
            </p>
          </div>

          <div className="flex items-center gap-6">
            <span className="text-foreground-400 text-xs">
              &copy; 2026 Kakobuy Spreadsheet
            </span>
            <a
              href="https://instagram.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-6 h-6 flex items-center justify-center text-foreground-500 hover:text-foreground-950 transition-colors"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line"></i>
            </a>
            <a
              href="https://discord.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-6 h-6 flex items-center justify-center text-foreground-500 hover:text-foreground-950 transition-colors"
              aria-label="Discord"
            >
              <i className="ri-discord-line"></i>
            </a>
            <a
              href="https://reddit.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-6 h-6 flex items-center justify-center text-foreground-500 hover:text-foreground-950 transition-colors"
              aria-label="Reddit"
            >
              <i className="ri-reddit-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}